import { useEffect } from "react";
import { Link } from "react-router-dom";
import { IMAGES } from "../lib/site";
import { Reveal } from "../components/Reveal";
import { Contact } from "../components/Contact";

export const GalleryPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main data-testid="gallery-page" className="bg-[#F9F9F6] pt-32 md:pt-36">
      <section className="px-6 md:px-12 lg:px-24 pb-16 md:pb-24">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 items-end">
          <Reveal className="md:col-span-7">
            <p className="text-[11px] uppercase tracking-[0.32em] text-[#965C3B]">
              Gallery
            </p>
            <h1
              data-testid="gallery-heading"
              className="mt-6 font-display text-5xl sm:text-6xl md:text-7xl lg:text-8xl tracking-tighter leading-[0.9] text-[#1A2B22]"
            >
              The horses,
              <br />
              <em className="italic font-normal text-[#965C3B]">
                the riders, the rings.
              </em>
            </h1>
          </Reveal>
          <Reveal delay={150} className="md:col-span-5 md:text-right">
            <p className="max-w-md md:ml-auto text-[#1A2B22]/75 leading-relaxed">
              An evolving portfolio of our Czech Warmbloods at home, in
              training, and competing across the South Florida circuit and
              beyond.
            </p>
            <Link
              to="/#contact"
              data-testid="gallery-cta"
              className="mt-8 inline-flex items-center gap-3 px-6 py-3 bg-[#1A2B22] text-[#F9F9F6] text-xs uppercase tracking-[0.24em] hover:bg-[#965C3B] transition-colors"
            >
              Inquire about a horse
              <span aria-hidden>→</span>
            </Link>
          </Reveal>
        </div>
      </section>

      <section className="px-6 md:px-12 lg:px-24 pb-24 md:pb-32">
        <div className="grid grid-cols-2 md:grid-cols-12 gap-3 md:gap-4 auto-rows-[180px] md:auto-rows-[220px]">
          {IMAGES.gallery.map((g, i) => (
            <Reveal
              key={i}
              delay={(i % 4) * 80}
              className={`overflow-hidden ${getSpan(i)}`}
            >
              <img
                src={g.src}
                alt={g.alt}
                data-testid={`gallery-image-${i}`}
                className="w-full h-full object-cover transition-transform duration-[1.4s] hover:scale-[1.05]"
                loading="lazy"
              />
            </Reveal>
          ))}
        </div>
      </section>

      <Contact />
    </main>
  );
};

// Asymmetric "tetris" bento spans
const getSpan = (i) => {
  const map = [
    "col-span-2 md:col-span-5 row-span-2",
    "col-span-2 md:col-span-7",
    "col-span-1 md:col-span-3",
    "col-span-1 md:col-span-4",
    "col-span-2 md:col-span-5 row-span-2",
    "col-span-2 md:col-span-7",
    "col-span-1 md:col-span-4",
    "col-span-1 md:col-span-3",
  ];
  return map[i % map.length];
};

export default GalleryPage;
